import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
const container = document.getElementById('root');
// ReactDOM.render(
//   <React.StrictMode>
//   <App />
// </React.StrictMode>,
//   document.getElementById('root') as HTMLElement
// );
if (!container) {
  throw new Error('No root element found');
}
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App/>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
